import { createContext, Dispatch, FC, ReactNode, SetStateAction, useContext } from 'react';
import { TRoute } from 'config/routes';

export type TExtendedRoute = TRoute & { key: string; params?: Record<string, unknown> };

export type TRouteData = {
  setCurrentRoute: Dispatch<SetStateAction<null | TExtendedRoute>>;
  currentRoute: TExtendedRoute | null;
};

type TProps = {
  value: TRouteData;
  children: ReactNode;
};

const RouteDataContext = createContext<TRouteData>({ setCurrentRoute: () => {}, currentRoute: null });

export const useRouteData = () => useContext(RouteDataContext);

export const RouteDataProvider: FC<TProps> = ({ value, children }) => {
  return <RouteDataContext.Provider value={value}>{children}</RouteDataContext.Provider>;
};
